export default __webpack_public_path__ + "static/Hoarding-Cleanout-6c3a128186f5afee014c081306aac74b.jpg";